export const autoIndent = (str, caret) => {
    let indented = '';
    let trimmed = str; 
    let lines = trimmed.split("\n");
    let fwd = 0;
    let bwd = 0;
    let indentChar = "  ";

    let caretCounter = 0;
    let newCaret = 0;

    for (let i in lines) {
        let line = lines[i];
        let numFwd = count(line, "("); 
        let numBwd = count(line, ")");
        let _numFwd = count(line, "{");
        let _numBwd = count(line, "}");
        let diff = fwd - bwd - _numBwd;
        let l = line.trimStart();
        let timed = times(indentChar, diff) + l;
        indented += timed;
        if (parseInt(i) < lines.length - 1) {
            indented += "\n";
        }
        
        fwd += numFwd + _numFwd;
        bwd += numBwd + _numBwd;

        if (caretCounter <= caret &&
            caret <= caretCounter + line.length + 1) {
            newCaret = caret + diff * 2;
        }
        // keep track of what the position we are at now
        caretCounter += line.length + 1;
    }
    return {indented, caret: newCaret};
};

const count = (str, x) => {
    let c=0;
    for (let i=0; i < str.length; i++) {
        if (str[i] == x) {
            c++;
        }
    }
    return c;
};

const times = (str, x) => {
    let s = "";
    for (let i=0; i < x; i++) {
        s += str;
    }
    return s;
};
